<template>
  <div class="col-lg-9">
    <h1>
      <template v-if="isCatalogOrder">Votre commande catalogue</template>
      <template v-else>Panier</template>
    </h1>

    <!--        <div class="container" style="">-->
    <!--            <div class="row" style="-->
    <!--                font-weight: bold;-->
    <!--                padding: 25px;-->
    <!--                margin: 50px 15px 50px 15px;-->
    <!--                border: 2px solid #0658a3;-->
    <!--                color: #0658a3;-->
    <!--            ">-->
    <!--                <div class="col-md-12" >-->
    <!--                    <i class="fa fa-info" style="    position: absolute;-->
    <!--    right: 5px;-->
    <!--    font-size: 36px;"></i>-->
    <!--                    <span>-->
    <!--                    <b>À ce jour le site PONROY fonctionne normalement</b>, vous pouvez commander et vous faire livrer à votre domicile. La livraison en relai colis est toujours possible, nous vous invitons à vous assurer que le point de retrait est bien ouvert au public (privilégier les tabacs, épiceries, presse et autres commerces alimentaires…).-->
    <!--<br/>-->
    <!--                    </span>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->

    <slot name="flashes"></slot>
    <div style="text-align: center;margin-top: 100px;color: rgb(153, 153, 153);" v-if="!cartIsLoaded">
      <i class="fa fa-circle-o-notch fa-spin fa-2x"></i><br/>
      <i>Chargement...</i>
    </div>
    <div v-else>
      <div class="advantageCode" v-if="isCatalogOrder">
        <div>
          <h4 class="text-center align-baseline">Vous avez un code avantage ?</h4>
        </div>
        <div>
          <a class="btn btn-primary" href="#" @click="doScroll" role="button">Ajouter mon code</a>
        </div>
      </div>
      <div class="resume breakpointNav" v-else>
        <div class="row">
          <div class="col-lg-8 text-center text-lg-left">Il y a {{ countItems }} articles dans votre panier</div>
          <div class="col-lg-4 text-center text-lg-right">Total de vos articles : <strong>{{
              itemsTotal | moneyFormat
            }}</strong></div>
        </div>
      </div>

      <div v-if="items">

        <ponroy-cart-item
          v-for="item in items"
          v-if="null !== item.orderable && 'site.repository.product_reference' === item.orderable.orderableRepository"
          :type="item.orderable.orderableRepository"
          :key="item.id"
          :reference="item.id"
          :title="item.orderable.data.title"
          :referenceTitle="item.referenceName"
          :referenceCode="item.orderableId"
          :referenceProduct="item.orderable.data.id"
          :unitPrice="item.unitPrice"
          :discountedUnitPrice="item.discountedUnitPrice"
          :total="item.total"
          :baseQuantity="item.quantity"
          :slug="item.orderable.data.slug"
          :mainImage="item.orderable.data.cardImage"
          :advantageName="item.advantageName"
        >
        </ponroy-cart-item>

        <ponroy-cart-item
          v-for="item in items"
          v-if="null !== item.orderable && 'site.repository.fidelity_gift' === item.orderable.orderableRepository"
          :type="item.orderable.orderableRepository"
          :key="item.id"
          :reference="item.id"
          :title="item.orderable.title"
          :referenceCode="item.orderable.id"
          :mainImage="item.orderable.image"
          :unitFidelityPoint="item.unitFidelityPoint"
          :total="item.totalFidelityPoint"
          :baseQuantity="item.quantity"
        >
        </ponroy-cart-item>

        <ponroy-cart-item
          v-for="item in items"
          v-if="null !== item.orderable && 'site.repository.gift' === item.orderable.orderableRepository && item.orderable.type !== 'sample' && item.orderable.type !== 'doc'"
          :type="item.orderable.orderableRepository"
          :key="item.id"
          :reference="item.id"
          :title="item.orderable.title"
          :referenceCode="item.orderable.id"
          :mainImage="item.orderable.image"
        >
        </ponroy-cart-item>

        <div class="blocChooseGift"
             v-if="items.length > 0 && undefined === gift && null !== giftsChoice && giftsChoice.length > 0 && giftsChoice.length <= 5">
          <div v-if="showErrorGiftChoice" id="error-gift-choice" class="alert alert-danger text-center">
            Merci de sélectionner un cadeau pour valider votre panier
          </div>
          <div class="d-lg-flex justify-content-around verticalChoice">
            <h2>Je choisis un cadeau</h2>

            <div class="custom-control custom-radio" v-for="g in giftsChoice" :key="g.id">
              <input :id="'radio_' + g.id" name="radio" type="radio" class="custom-control-input" :value="g.id"
                     @change="e => chooseGift(g)">
              <label class="custom-control-label" :for="'radio_' + g.id">
                <span class="thumbGift"><img :data-src="g.image" :alt="g.title" class="lazyload img-fluid"></span>
                {{ g.title }}
              </label>
            </div>
          </div>
        </div>

        <div class="blocChooseGift"
             v-if="items.length > 0 && undefined === gift && null !== giftsChoice && giftsChoice.length > 5">
          <div v-if="showErrorGiftChoice" id="error-gift-choice" class="alert alert-danger text-center">
            Merci de sélectionner un cadeau pour valider votre panier
          </div>
          <div class="d-lg-flex justify-content-around verticalChoice">
            <h2 class="align-self-center">Je choisis un cadeau</h2>

            <div class="align-self-center" style="text-align: center;">
              <v-select :options="giftsChoice" label="fullTitle" v-model="selectedGift"></v-select>
              <!--<select class="form-control mb-2 gift-select2" v-model="selectedGift">-->
              <!--<option disabled>Choisissez un cadeau</option>-->
              <!--<option v-for="g in giftsChoice" :value="g.id" :key="g.id">{{g.id}} - {{ g.title }}</option>-->
              <!--</select>-->
              <button type="button" class="btn btn-primary" @click="e => validateSelectedGift()">Valider mon cadeau
              </button>
            </div>
            <!--<div class="custom-control custom-radio" v-for="g in giftsChoice" :key="g.id">-->
            <!--<input :id="'radio_' + g.id" name="radio" type="radio" class="custom-control-input" :value="g.id" @change="e => chooseGift(g)">-->
            <!--<label class="custom-control-label" :for="'radio_' + g.id">-->
            <!--<span class="thumbGift"><img :data-src="g.image" :alt="g.title" class="lazyload img-fluid"></span>-->
            <!--{{ g.title }}-->
            <!--</label>-->
            <!--</div>-->
          </div>
        </div>

        <div class="teaser" v-if="teaser && shippingFees && shippingFees.amount > 0 && items.length > 0">
          <div v-html="teaser"></div>
        </div>
      </div>

      <div class="row" v-if="filtredRecommendedProducts.length">
        <div class="col-md-12">
          <div style="
    background: rgba(119, 135, 129, 0.2);
    color: #778781;
    padding: 0 10px;
    display: inline-block;
    font-size: 1rem;
    font-weight: bolder;
    border-radius: 0.25rem 0.25rem 0 0;">Nous vous recommandons
          </div>
        </div>

        <ponroy-cart-recommendation
          v-for="item in recommendedProduct"
          v-if="!inCart(item.id)"
          :key="item.id"
          repository="site.repository.product_reference"
          :item="item"
          :reference="item.id"
        >
        </ponroy-cart-recommendation>
      </div>


      <ponroy-cart-search :repository="repository" :is-catalog-order="isCatalogOrder"></ponroy-cart-search>

      <ponroy-cart-samples v-if="promotion && promotion.hasSample"></ponroy-cart-samples>

      <div class="row">
        <div class="col-lg-5">
          <div id="blocCodePromo" class="blocCodePromo text-center" v-if="!promotion || promotion.automatic">
            <h4>Code avantage</h4>
            <p>Si vous disposez d'un code avantage,<br> veuillez le noter ci-dessous</p>
            <form class="form-inline" :action="enterPromoUrl" method="POST">
              <input type="hidden" name="no_redirect">


              <div class="form-group">
                <label for="coupon_code" class="sr-only">Code avantage</label>
                <input v-model="couponText" type="text" name="coupon_code" class="form-control" id="coupon_code_input"
                       placeholder="Code avantage">
              </div>

              <div v-if="hasHomeInput && !awaitingHasHomeInput" class="form-group">
                <label for="code_home" class="sr-only">Code client</label>
                <input type="text" name="code_home" class="form-control" placeholder="Code client">
              </div>

              <button style="margin: auto" v-if="awaitingHasHomeInput" disabled type="submit" class="btn"><i
                class="fa fa-spinner fa-spin"></i></button>
              <button style="margin: auto" v-else type="submit" class="btn" :data-trk-promo-code="couponText">
                Appliquer
              </button>
            </form>
          </div>
          <div class="blocCodePromo text-center" v-else>
            <h4><small>Votre promotion</small> <br>{{ promotionCode }}</h4>
            <div v-html="promotion.cartText"></div>
            <form class="form-inline" :action="enterPromoUrl" method="POST">
              <input type="hidden" name="coupon_code">
              <button type="submit" class="btn btnDelete">Annuler ce code avantage</button>
            </form>
          </div>
        </div>
        <div class="col-lg-7">
          <div class="blocTotal">
            <div class="lineTotalArticles">
              <div class="row">
                <div class="col-8">Total de vos articles</div>
                <div class="col-4">{{ itemsTotal | moneyFormat }}</div>
              </div>
            </div>
            <div class="lineTotalFidelityGift" v-if="totalFidelityPoint > 0">
              <div class="row">
                <div class="col-8">Total de vos cadeaux</div>
                <div class="col-4">{{ totalFidelityPoint }} points</div>
              </div>
            </div>
            <div class="lineCodePromo" v-if="discountAmount != 0">
              <div class="row">
                <div class="col-8">Code avantage <code>{{ promotionCode }}</code></div>
                <div class="col-4">{{ discountAmount | moneyFormat }}</div>
              </div>
            </div>
            <div class="lineLivraison">
              <div class="row" v-if="shippingFees">
                <div class="col-8">Frais de livraison
                  <small v-if="teaser && shippingFees.amount > 0 && items.length > 0" v-html="teaser"></small>
                </div>
                <div class="col-4">{{ shippingFees.amount | moneyFormat }}</div>
              </div>
            </div>
            <div class="lineTotal">
              <div class="row">
                <div class="col-6 col-lg-8 text-left text-lg-right">&nbsp;&nbsp;TOTAL</div>
                <div class="col-6 col-lg-4">{{ total | moneyFormat }}</div>
              </div>
            </div>
            <div class="lineFidelite" v-if="gain > 0 && showFidelityPoints">
              Votre commande vous rapporte <strong>{{ gain }} point{{ gain > 1 ? 's' : '' }} fidélité <i
              class="fa fa-heart"></i></strong>
            </div>
          </div>

          <button @click="e => validate(e)" type="submit"
                  :class="{ 'btn-primary' : isValid(), 'disabled' : !isValid() }"
                  class="btn btnSubmitCart float-lg-right">Valider mon panier
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState, mapActions, mapGetters} from 'vuex';

import store from '../store';
import CartItem from './CartItem.vue';

import vSelect from 'vue-select';
import request from "../store/utils/request";

const Cart = {
  name: 'ponroy-cart',
  store,
  components: {
    CartItem,
    vSelect
  },
  props: {
    repository: {
      type: String,
      required: true,
    },
    showFidelityPoints: Number | Boolean,
    isAuthorized: Boolean
  },
  data: function () {
    return {
      showErrorGiftChoice: false,
      selectedGift: null,
      couponText: null,
      awaitingCouponText: false,
      hasHomeInput: false,
      awaitingHasHomeInput: false,
    };
  },
  computed: {
    ...mapState('cart', ['data']),
    ...mapGetters('cart', [
      'items',
      'itemsTotal',
      'countItems',
      'total',
      'gain',
      'totalFidelityPoint',
      'shippingFees',
      'promotionCode',
      'promotion',
      'discountAmount',
      'giftsChoice',
      'gift',
      'teaser',
      'recommendedProduct',
      'sampleItems',
      'samples',
      'cartIsLoaded',
      'lockGiftChoices',
    ]),
    enterPromoUrl: function () {
      return Routing.generate('site_enter_promotion');
    },
    isCatalogOrder: function () {
      return new URL(location.href).searchParams.get('orig') === "offre_catalogue";
    },
    filtredRecommendedProducts: function () {
      return this.recommendedProduct.filter((item) => !this.inCart(item.id));
    }
  },
  methods: {
    ...mapActions('cart', ['addToCart', 'setLockGiftChoices']),
    isValid() {

      // if (this.promotion && this.promotion.hasSample && this.samples.length > 0 && this.sampleItems.length < 2) {
      //     return false;
      // }

      if (
        this.isAuthorized
        && this.countItems > 0
        && this.giftsChoice && (
          this.giftsChoice.length === 0
          || (this.giftsChoice.length > 0 && typeof this.gift !== 'undefined')
        )
      ) {
        return true;
      }
      return false;
    },
    validate(e) {
      e.preventDefault();

      if (this.isValid()) {
        window.location.href = Routing.generate('site_checkout_login');
      } else {
        this.showErrorGiftChoice = true;
      }
    },
    chooseGift(gift) {
      this.showErrorGiftChoice = false;
      if (!this.lockGiftChoices) {
        this.setLockGiftChoices(true);

        this.addToCart({
          orderable: {repository: 'site.repository.gift', id: gift.id},
          quantity: 1
        });
      }

    },
    validateSelectedGift(e) {
      if (this.selectedGift !== null) {
        this.chooseGift({id: this.selectedGift.id});
      }
    },
    inCart: function (needle) {

      let length = 0;

      if (this.items) {
        length = this.items.length;
      }

      for (let i = 0; i < length; i++) {
        if (this.items[i].orderableId === needle) return true;
      }

      return false;
    },
    doScroll() {
      document.getElementById('coupon_code_input').focus();
      document.getElementById('coupon_code_input').style.border = '2px solid #F39879';
    }
  },
  watch: {
    couponText: function (el) {
      if (!this.awaitingCouponText) {
        setTimeout(() => {

          if ("" !== this.couponText) {
            let result = request
              .get(Routing.generate('site_enter_promotion_home', {'coupon_code': this.couponText}))
              .then(response => (this.hasHomeInput = response.data.has_home_input, this.awaitingHasHomeInput = false));
          }

          this.awaitingCouponText = false;
        }, 1000); // 1 sec delay
      }

      this.awaitingHasHomeInput = true;
      this.awaitingCouponText = true;

    }
  },
};

export default Cart;

</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/Cart.vue